import React from 'react';
import { ColumnsType } from 'antd/es/table';
import DetalleMetrica from './DetalleMetrica';

const DetalleAplicacionCompras: React.FC = () => {
  const columns: ColumnsType<any> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Nro. Contrato',
      dataIndex: 'nro_contrato',
      key: 'nro_contrato',
      width: 150,
    },
    {
      title: 'Fecha Contrato',
      dataIndex: 'fecha_contrato',
      key: 'fecha_contrato',
      width: 120,
    },
    {
      title: 'Comprador',
      dataIndex: 'comprador',
      key: 'comprador',
      width: 200,
    },
    {
      title: 'Vendedor',
      dataIndex: 'vendedor',
      key: 'vendedor',
      width: 200,
    },
    {
      title: 'Nro. Fardo',
      dataIndex: 'nro_fardo',
      key: 'nro_fardo',
      width: 120,
      align: 'right' as const,
    },
    {
      title: 'Nro. Lote',
      dataIndex: 'nro_lote',
      key: 'nro_lote',
      width: 120,
      align: 'right' as const,
    },
    {
      title: 'Cliente',
      dataIndex: 'cliente',
      key: 'cliente',
      width: 200,
    },
    {
      title: 'Origen',
      dataIndex: 'origen',
      key: 'origen',
      width: 200,
    },
  ];

  const fetchData = async (idEmpresa: number, idProducto: number, token: string): Promise<any[]> => {
    const url = `${process.env.REACT_APP_ESTADISTICAS_URL}/detalle/aplicacion-compras/${idEmpresa}/${idProducto}/`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error al cargar datos: ${response.status}`);
    }

    return await response.json();
  };

  return (
    <DetalleMetrica
      titulo="Detalle de Aplicación Compras"
      descripcion="Fardos aplicados a contratos de compra"
      fetchData={fetchData}
      columns={columns}
      nombreArchivo="aplicacion_compras"
    />
  );
};

export default DetalleAplicacionCompras;

